import { createFileRoute } from "@tanstack/react-router";
import { readLastWorkspace } from "../features/auth/lastWorkspace";
import { allWorkspaces, useSession } from "../features/auth/session";
import { FullScreenSpinner } from "../features/shell/FullScreenSpinner";
import { Redirect } from "../features/shell/Redirect";

export const Route = createFileRoute("/")({ component: Index });

function Index() {
  const session = useSession();
  if (session.status === "loading") return <FullScreenSpinner />;
  if (session.status === "anon") return <Redirect to="/login" replace />;
  // Across every account on the device, not just the active one: with a workspace under each of two
  // addresses, counting only the active account's sends you straight back into the one you just left.
  // The one you were in last, when this browser still has it; else the first.
  const all = allWorkspaces(session.accounts, session.workspaces);
  const last = readLastWorkspace();
  const ws = (last ? all.find((w) => w.slug === last || w.id === last) : undefined) ?? all[0];
  if (!ws) return <Redirect to="/new" replace />;
  return <Redirect to="/w/$ws" params={{ ws: ws.slug || ws.id }} replace />;
}
